/**
 * @author PoornaChandu
 * @description updated code
 */
import React, { useEffect, useRef, useState } from 'react';
import themeSettings from './Utils/themeSettings.json';
import { API_BACKUP } from '../../../commons/api';
import { Button, Form, Input, Select, message } from 'antd';
import { connect } from 'react-redux';
import { submitTask, SchemasList } from './Utils/FormCalls';

const { Option } = Select;
const APIList = {
  createData: `${API_BACKUP.ConfigCreate}`,
  GetSchemasList: `${API_BACKUP.TasksGetSchemas}`
};

const Configuration = (props) => {
  const [formObject, setFormObject] = useState({});
  const [schemaList, setSchemaList] = useState([]);
  const [userProfile,setUserProfile] = useState(props.userProfile);
  const [translationCache,setTranslationCache] = useState(props.translationCache);
  // const [checkedVal, setCheckedVal] = useState('Active');
  const formRef = useRef(null);

  useEffect(() => {
    const fetchSchemas = async () => {
      const schemas = await SchemasList(APIList.GetSchemasList);
      setSchemaList(schemas);
    };
    fetchSchemas();
  }, []);

  useEffect(() => {
    if (
      props.userProfile !== userProfile ||
      props.translationCache !== translationCache
    ) {
      setTranslationCache(props.translationCache);
      setUserProfile(props.userProfile);
    }  }, [userProfile, translationCache]);

  const onFormSubmit = () => {
    formRef.current
      .validateFields()
      .then(async (values) => {
        values = {
          ...formRef.current.getFieldsValue()
        };
        if (values && values.Id === undefined) {
          const response = await submitTask(APIList.createData, values);
          message.success(response && response.message ? translation(response.message) : '');
          if (formRef.current) {
            formRef.current.setFieldsValue({
              Schema: null,
              TemporaryFilesPath: null,
              StorageLocation: null,
              ServerCredentials: null,
              StoragePath: null
            });
          }
          setFormObject({});
        }
      })
      .catch((error) => console.log(error));
  };

  const resetFields = () => {
    if (formRef.current) {
      formRef.current.setFieldsValue({
        Schema: null,
        TemporaryFilesPath: null,
        StorageLocation: null,
        ServerCredentials: null,
        StoragePath: null
      });
    }
    setFormObject({});
  };

  // const onCheckboxChange = (e) => {
  //   setCheckedVal(e.target.checked ? 'Active' : 'InActive');
  // };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const formItemLayout = { width: '100%', flex: '50%' };

  return (
    <Form
      ref={formRef}
      initialValues={formObject}
      name="basic"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
    >
      <Form.Item name="Id"></Form.Item>
      <Form.Item
        label={translation('Schema')}
        name="Schema"
        style={formItemLayout}
      >
        <Select style={{ width: '400px' }} placeholder={translation('Please Select Schema')}>
          {schemaList &&
            Array.isArray(schemaList) &&
            schemaList.map((table) => (
              <Option value={table.Value} key={table.Key}>
                {table.Key}
              </Option>
            ))}
        </Select>
      </Form.Item>
      <Form.Item
        label={translation('Temporary Files Path')}
        name="TemporaryFilesPath"
        style={formItemLayout}
      >
        <Input
          style={{ width: '400px' }}
          placeholder={translation('Please Enter Temporary files path')}
        />
      </Form.Item>
      <Form.Item
        label={translation('Storage Location')}
        name="StorageLocation"
        style={formItemLayout}
      >
        <Select
          style={{ width: '400px' }}
          placeholder={translation('Please Select Storage location')}
        >
          <Option value={'Azure Blob'} key={'Azure Blob'}>
            {'Azure Blob'}
          </Option>
          <Option value={'AWS S3'} key={'AWS S3'}>
            {'AWS S3'}
          </Option>
          <Option value={'Local Infra (FTP)'} key={'Local Infra (FTP)'}>
            {'Local Infra (FTP)'}
          </Option>
        </Select>
      </Form.Item>

      <Form.Item
        label={translation('Server Credentials')}
        name="ServerCredentials"
        style={formItemLayout}
      >
        <Input
          style={{ width: '400px' }}
          placeholder={translation('Please Enter Server credentials')}
        />
      </Form.Item>
      <Form.Item
        label={translation('Storage Path')}
        name="StoragePath"
        style={formItemLayout}
      >
        <Input
          style={{ width: '400px' }}
          placeholder={translation('Please Enter Storage Path')}
        />
      </Form.Item>
      <div style={{ display: 'flex', justifyContent: 'right' }}>
        <Form.Item>
          <Button
            style={{ marginRight: 8 }}
            theme={themeSettings}
            type="primary"
            onClick={onFormSubmit}
            data-testid="submitButton"
          >
            {translation('Submit')}
          </Button>
        </Form.Item>
        <Form.Item>
          <Button
            style={{ marginRight: 8 }}
            theme={themeSettings}
            type="primary"
            onClick={resetFields}
          >
            {translation('Cancel')}
          </Button>
        </Form.Item>
      </div>
    </Form>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  userProfile: state.LayoutReducer.userProfile
});

export default connect(mapStateToProps)(Configuration);